import { render, staticRenderFns } from "./HotLink.vue?vue&type=template&id=4e6cfd56&scoped=true"
import script from "./HotLink.vue?vue&type=script&lang=js"
export * from "./HotLink.vue?vue&type=script&lang=js"
import style0 from "./HotLink.vue?vue&type=style&index=0&id=4e6cfd56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6cfd56",
  null
  
)

export default component.exports